module.exports = __webpack_public_path__ + "img/ic_change.32cb1023.png";